// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    activity: 'Activité',
    add_check_list_item_placeholder: 'Ajouter un élément à la liste de contrôle ou utiliser Ctrl+V pour coller une liste d’éléments',
    add_checklist_label: 'Ajouter une liste de contrôle',
    add_more: 'Ajouter plus',
    add_reaction_title: 'Ajouter une réaction',
    ai: 'IA',
    ai_analyzing: 'Analyse des modèles',
    ai_building: 'Création du modèle de prévision',
    ai_description: 'La prévision IA de {brandName} utilise des algorithmes d’apprentissage automatique pour identifier des modèles et des relations entre les événements et les actions en traitant les données historiques de votre compte. En conséquence, elle affiche la date de fin de projet la plus probable et la confiance en cette prédiction.',
    ai_forecast: 'Prévision IA',
    ai_forecast_date: 'Date de fin de projet prévue par l’IA',
    ai_how_works: 'En savoir plus sur le fonctionnement de l’IA',
    ai_not_enough_data: 'Pas assez de données historiques pour effectuer une prévision fiable. Une utilisation active du système assurera des prévisions plus précises. <a href={0} target=\'_blank\' class={1}>En savoir plus</a> sur la prévision IA.',
    ai_planned_date: 'Date de fin de projet planifiée',
    ai_result: 'Résultats de la prévision IA',
    ai_reviewing: 'Analyse des données historiques',
    apply: 'Appliquer',
    available: 'Disponible',
    back: 'Retour',
    CanChangeWorkflowForProjectOutdatedData: 'Le flux de travail est déjà appliqué au projet. Veuillez actualiser la page pour mettre à jour les données.',
    CanDeleteCategoryHasTask: 'Il est impossible de supprimer une catégorie utilisée dans des activités.',
    CanDeletePriorityHasProject: 'Il est impossible de supprimer une priorité utilisée dans des projets.',
    CanDeletePriorityHasTask: 'Il est impossible de supprimer une priorité utilisée dans des activités.',
    CanDeletePriorityIsInternal: 'Il est impossible de supprimer une priorité système interne.',
    CanDeleteStatusIsWorkflowTypeStatus: 'Il est impossible de supprimer le statut par défaut.',
    CanDeleteStatusUsed: 'Il est impossible de supprimer un statut utilisé dans une entité.',
    CanDeleteThresholdIsInternal: 'Il est impossible de supprimer un seuil système interne.',
    CanDeleteVacationTypeDefault: 'Il est impossible de supprimer le type de congé par défaut.',
    CanDeleteVacationTypeHasVacation: 'Il est impossible de supprimer un type de congé qui a des congés attribués.',
    CanDeleteWorkflowIsSingle: 'Il doit y avoir au moins un flux de travail dans le système.',
    CanDeleteWorkflowIsUsed: 'Il est impossible de supprimer un flux de travail utilisé dans des projets.',
    CanDisableStatusIsUsed: 'Il est impossible de désactiver un statut utilisé dans une entité',
    CanDisableStatusIsWorkflowTypeStatus: 'Il est impossible de désactiver le statut par défaut',
    CanEdit_Task_AccessDenied: 'Vous n’avez pas la permission de modifier cette activité',
    CanEditValueThresholdIsInternal: 'Les valeurs de seuil prédéfinies du système ne peuvent pas être modifiées.',
    CanSetWorkflowTypeStatusIsWorkflowTypeStatus: 'Il est impossible de définir un statut déjà par défaut comme statut par défaut.',
    change: 'changer',
    ChangeProjectProgressError: 'La progression d’un projet avec des tâches ne peut pas être modifiée.',
    ChangeTaskProgressError: 'La progression d’une tâche parente ne peut pas être modifiée.',
    check_all_label: 'Tout cocher',
    checklist_name: 'Liste de contrôle',
    column_group_custom_fields: 'Champs personnalisés',
    column_group_custom_fields_user: 'Champs personnalisés utilisateur',
    columns: 'Colonnes',
    Completed_Projects: 'Projets terminés',
    Completed_Tasks: 'Activités terminées',
    Copy_Text: 'Copier',
    copyPostfix: 'Copie',
    create: 'Créer',
    created_by: 'Créé par',
    creation_date: 'Date de création',
    current_plan: 'Forfait actuel : <b>{0}</b>',
    dates: 'Dates',
    delete_checklist_label: 'Supprimer la liste de contrôle',
    description_title: 'Description',
    edit_check_list_item_placeholder: 'Modifier l’élément de la liste de contrôle',
    Edit_Text: 'Modifier',
    emoji: 'Émoji',
    empty_list: 'Aucun résultat n’a été trouvé pour la requête de recherche/le filtre appliqué',
    error_reload: 'La version de {brandName} a été mise à jour. Pour assurer le bon fonctionnement de l’application, vous devez recharger la page.',
    export: 'Exporter',
    export_csv: 'Exporter au format CSV',
    export_pdf: 'Exporter au format PDF',
    filters: 'Filtres',
    freeze: 'Figer la colonne',
    from: 'De',
    general: 'Général',
    global_search: 'Rechercher',
    global_search_text: 'Rechercher des messages, des fichiers et plus encore',
    GotIt: 'Compris',
    group_by: 'Grouper par',
    group_by_template: 'Grouper par : {0}',
    here: 'ici',
    hourly_rate_unit: '/h',
    icons: 'Icônes',
    in: 'dans',
    in_use: 'En cours d’utilisation',
    items_text: '1#{0} élément#{0} éléments',
    job_role: 'Rôle',
    label_custom_date_range: 'Plage de dates personnalisée',
    label_daily: 'Quotidien',
    label_monthly: 'Mensuel',
    label_weekly: 'Hebdomadaire',
    label_yearly: 'Annuel',
    least_likely: 'Moins probable',
    month: 'Mois',
    MoreActions: 'Plus d’actions',
    most_likely: 'Le plus probable',
    move_down: 'Descendre',
    move_up: 'Monter',
    name_title: 'Nom',
    next_month: 'Mois prochain',
    next_week: 'Semaine prochaine',
    no: 'Non',
    no_available_filters: 'Aucune valeur disponible pour le filtre',
    no_data_to_display: 'Aucune donnée à afficher',
    no_data_to_display_for_widget: 'Aucune donnée à afficher. Les filtres, y compris ceux spécifiques au widget et les filtres généraux, peuvent empêcher l’affichage des données.',
    NoPermissionToArchiveProject: 'Action demandée (archiver le projet) non disponible pour la raison suivante : Vous n’avez pas la permission d’archiver le projet.',
    not_calculated: 'Non calculé',
    not_in_use: 'Non utilisé',
    pause: 'Pause',
    PortfolioLimitError: 'Vous avez atteint la limite de 60 portefeuilles dans l’édition Équipe. Veuillez passer à l’édition Entreprise de {brandName}.',
    previous_month: 'Mois précédent',
    previous_week: 'Semaine précédente',
    previous_year: 'Année précédente',
    qb_disconnect_denied: 'Vous n\'avez pas de jeton QuickBooks associé à ce compte',
    quarter: 'Trimestre',
    quick_search_placeholder: 'Rechercher par ID ou nom',
    quick_search_placeholder_for_archive: 'Rechercher les projets archivés par nom ou ID',
    RateLimitExceededByAccount: 'Nous nous excusons pour la gêne occasionnée, mais en raison d\'un trafic élevé, nous limitons actuellement le nombre de requêtes que vous pouvez effectuer. Veuillez réessayer plus tard.',
    RateLimitExceededByUser: 'Nous nous excusons pour la gêne occasionnée, mais en raison d\'un trafic élevé, nous limitons actuellement le nombre de requêtes que vous pouvez effectuer. Veuillez réessayer plus tard.',
    read_more: 'En savoir plus',
    RecordConversionToActivityDifferentWorkflows: 'Il est impossible de convertir l\'enregistrement, car des workflows différents ont été appliqués au projet et au modèle.',
    records: 'Enregistrements',
    remove_checklist_item_label: 'Supprimer l\'élément de la checklist',
    request_resources: 'Demander des ressources',
    reset_timer_title: 'Réinitialiser le minuteur',
    resource_type_label: 'Type de ressource',
    resume: 'Reprendre',
    role: 'Rôle',
    schedule_hours: 'Programmer les heures',
    security_group: 'Niveau d\'accès',
    select: 'Sélectionner',
    share: 'Partager',
    short_quarter0: 'T1',
    short_quarter1: 'T2',
    short_quarter2: 'T3',
    short_quarter3: 'T4',
    show: 'Afficher',
    show_template: 'Afficher : {0}',
    skillsDeleteConfirm: 'La compétence sera supprimée des profils d\'autres utilisateurs et des rôles de poste où elle est utilisée',
    SnapshotsLimitError: 'Vous avez atteint la limite de 3 instantanés de projet. Veuillez passer à {brandName} Enterprise Edition.',
    sort: 'Trier',
    sort_activities: 'Trier les activités par :',
    sort_ascending: 'Tri croissant',
    sort_az: 'Trier A→Z',
    sort_descending: 'Tri décroissant',
    sort_projects: 'Trier les projets par :',
    sort_resources: 'Trier les ressources par :',
    sort_za: 'Trier Z→A',
    start: 'Démarrer',
    start_analyze: 'Démarrer l\'analyse',
    start_new_project: 'Démarrer un nouveau projet',
    stop_timer_title: 'Arrêter le minuteur',
    sub_features_list_title: 'Cette fonctionnalité inclut :',
    SystemTaskCreatorName: 'Système',
    Task_CanAccessBillingInformation_AccessDenied: 'Vous n\'avez pas les autorisations pour modifier les paramètres de facturation de cette activité',
    this_month: 'Ce mois-ci',
    this_week: 'Cette semaine',
    this_year: 'Cette année',
    ThresholdValueDuplicate: 'Cette valeur de seuil a déjà été ajoutée.',
    TimeoutErrorMessage: 'Votre demande a expiré. Veuillez réessayer plus tard.',
    to: 'À',
    today: 'Aujourd\'hui',
    uncheck_all_label: 'Tout décocher',
    unfreeze: 'Débloquer la colonne',
    UnknownErrorMessage: 'Désolé, une erreur s\'est produite... Veuillez actualiser la page.',
    update_date: 'Date de mise à jour',
    updated_by: 'Mis à jour par',
    upgrade: 'Mettre à niveau',
    upgrade_to_enterprise: 'Mettre à niveau vers Enterprise',
    usage: 'Utilisation',
    week: 'Semaine',
    WindowUnload_UnsavedChanges: 'Des modifications non enregistrées existent. Êtes-vous sûr de vouloir quitter cette page ?',
    year: 'Année',
    yes: 'Oui',
    yesterday: 'Hier',
};
